<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Request List for {{rewardName}} <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>Export</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" placeholder="To: dd / mm / yy"
							[showIcon]="true"></p-calendar>
					</li>
					<li>
						<button class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>
					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table #dt [value]="rewardlist" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadRewards($event)" [totalRecords]="totalRecords"
						[rowsPerPageOptions]="[5,10,15,20]"
						styleClass="p-datatable-gridlines p-datatable-striped p-datatable">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="player_name">
									<div class="p-d-flex p-jc-between p-ai-center">
										Player Name
										<p-sortIcon field="player_name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="mobile_no">
									<div class="p-d-flex p-jc-between p-ai-center">
										Mobile No.
                                        <p-sortIcon field="mobile_no"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="created_at">
									<div class="p-d-flex p-jc-between p-ai-center">
										Request Date
                                        <p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="reward_name">
									<div class="p-d-flex p-jc-between p-ai-center">
										Reward Name
                                        <p-sortIcon field="reward_name"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="required_size">
									<div class="p-d-flex p-jc-between p-ai-center">
										Required Size
                                        <p-sortIcon field="required_size"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="delivery_status" class="statusTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Delivery Status
										<p-sortIcon field="delivery_status"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="approved_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Approved By
                                        <p-sortIcon field="approved_by"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="email_id" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Email Id
                                        <p-sortIcon field="email_id"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="state" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										State
                                        <p-sortIcon field="state"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="city" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										City
                                        <p-sortIcon field="city"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="zipcode" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Zipcode
                                        <p-sortIcon field="zipcode"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="address" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Address
                                        <p-sortIcon field="address"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD  p-frozen-column">
									Action
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="player_name">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'player_name', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['player_name'] ? dt.filters['player_name'].value : ''" />
								</th>
                                <th [ngSwitch]="mobile_no">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'mobile_no', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['mobile_no'] ? dt.filters['mobile_no'].value : ''" />
								</th>
                                <th [ngSwitch]="created_at">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="dt.filter($event,'created_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="calvalue"></p-calendar>
								</th>
                                <th [ngSwitch]="reward_name">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'reward_name', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['reward_name'] ? dt.filters['reward_name'].value : ''" />
								</th>
                                <th [ngSwitch]="required_size">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'required_size', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['required_size'] ? dt.filters['required_size'].value : ''" />
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId2 [options]="statuses"
										(onChange)="dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
                                <th [ngSwitch]="delivery_status" class="statusTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-dropdown #pDropDownId [options]="dstatuses"
										(onChange)="dt.filter($event.value, 'delivery_status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Delivery Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
                                <th [ngSwitch]="approved_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'approved_by', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['approved_by'] ? dt.filters['approved_by'].value : ''" />
								</th>
                                <th [ngSwitch]="email_id" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'email_id', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['email_id'] ? dt.filters['email_id'].value : ''" />
								</th>
                                <th [ngSwitch]="state" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'state', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['state'] ? dt.filters['state'].value : ''" />
								</th>
                                <th [ngSwitch]="city" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'city', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['city'] ? dt.filters['city'].value : ''" />
								</th>
                                <th [ngSwitch]="zipcode" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'zipcode', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['zipcode'] ? dt.filters['zipcode'].value : ''" />
								</th>
                                <th [ngSwitch]="address" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'address', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['address'] ? dt.filters['address'].value : ''" />
								</th>
                                <th class="actionTD  p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-reward>
							<tr class="p-selectable-row">
								<td>
									{{reward.playerdata[0].fullName}}
								</td>
                                <td>
									{{reward.playerdata[0].mobileNumber}}
								</td>
                                <td>
									{{reward.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td>
									{{reward.reward_name}}
								</td>
                                <td>
									{{reward.size}}
								</td>
                                <td class="status-Td statusTd">
                                    <p-tag [ngClass]="getClassOf(reward.status)" value=" {{ reward.status }}" [rounded]="true">

                                    </p-tag>
                                </td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.delivery_status}}
								</td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.approved_by}}
								</td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.playerdata[0].email}}
								</td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.statename}}
								</td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.cityname}}
								</td>
                                <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.zipcode}}
								</td>
                                 <td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{reward.address}}
								</td>
								<td class="actionTD  p-frozen-column">
									<ul class="actionList">										
                                        <ng-container *ngIf="reward.status === 'Pending'; else otherBlock">
                                            <li>
                                                <button class="addBTn show-column" (click)="mark_as_delivered(reward.id)"> Mark as Delivered </button>
                                            </li>
                                        </ng-container>
                                        <ng-template #otherBlock>
                                            <li>
                                                <button class="addBTn show-column"> Delivered </button>
                                            </li>
                                            <li>
                                                <button class="addBTn show-column" (click)="delivered_comment(reward.id)"><img src="../../../assets/images/backend-image/common-images/notification.svg"></button>
                                            </li>
                                        </ng-template>
									</ul>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="12">No Rewards found.</td> 
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
<p-dialog header="Mark as Delivered" [(visible)]="markasDeliveredModal" [modal]="true" [style]="{ width: '500px' }" [draggable]="false" [resizable]="false" class="modal-payment-select">
  <form [formGroup]="deleveryForm">
    <div class="p-grid">  
        <div class="col-12 mb-3">
			<label class="popUp_label" for="comment">Comment</label>
			<div class="form-div">
				<textarea
				pInputTextarea
				rows="4"
				class="form-control"
				formControlName="comment"
				[ngClass]="{ 'is-invalid': submitted && f.comment.errors }">
				</textarea>
			</div>
			<div *ngIf="submitted && f.comment.errors" class="invalid-feedback d-block">
				<div *ngIf="f.comment.errors.required">Comment is required</div>
			</div>
		</div>
        <div class="col-12 footer-forms">
            <button class="btn btn-success" (click)="onSubmit()"> Submit </button>
        </div>
    </div>
  </form>
</p-dialog>
<p-dialog header="Delivery Comment" [(visible)]="deliveredModal" [modal]="true" [style]="{ width: '500px' }" [draggable]="false" [resizable]="false" class="modal-payment-select">
<div class="p-grid">  
    <div class="col-12 mb-3">
        <label class="popUp_label" for="comment">Comment</label>
        <div class="form-div">
            <textarea inputId="textarea" pInputTextarea rows="4" class="form-control" readonly [(ngModel)]="delivered_message"></textarea>
        </div>
    </div>
</div>
</p-dialog>